const hasSymbol = typeof Symbol === "function";
const webpackQueues = hasSymbol ? Symbol("webpack queues") : "__webpack_queues__";
const webpackExports = hasSymbol ? Symbol("webpack exports") : "__webpack_exports__";
const webpackError = hasSymbol ? Symbol("webpack error") : "__webpack_error__";

const resolveQueue = function(queue) {
	if(queue && queue.d < 1) {
		queue.d = 1;
		queue.forEach(function(fn) { fn.r--; });
		queue.forEach(function(fn) { fn.r-- ? fn.r++ : fn(); });
	}
}
const wrapDeps = function(deps) { return deps.map(function(dep) {
	if(dep !== null && typeof dep === "object") {

		if(dep[webpackQueues]) return dep;
		if(dep.then) {
			const queue = [];
			queue.d = 0;
			dep.then(function(r) {
				obj[webpackExports] = r;
				resolveQueue(queue);
			}, function(e) {
				obj[webpackError] = e;
				resolveQueue(queue);
			});
			const obj = {};

			obj[webpackQueues] = function(fn) { fn(queue); };
			return obj;
		}
	}
	const ret = {};
	ret[webpackQueues] = function() {};
	ret[webpackExports] = dep;
	return ret;
}); };
__webpack_require__.a = function(module, body, hasAwait) {
	var queue;
	hasAwait && ((queue = []).d = -1);
	const depQueues = new Set();
	const exports = module.exports;
	var currentDeps;
	var outerResolve;
	var reject;
	const promise = new Promise(function(resolve, rej) {
		reject = rej;
		outerResolve = resolve;
	});
	promise[webpackExports] = exports;
	promise[webpackQueues] = function(fn) { queue && fn(queue), depQueues.forEach(fn), promise["catch"](function() {}); };
	module.exports = promise;
	const handle = function(deps) {
		currentDeps = wrapDeps(deps);
		var fn;
		const getResult = function() { return currentDeps.map(function(d) {

			if(d[webpackError]) throw d[webpackError];
			return d[webpackExports];
		}); }
		const promise = new Promise(function(resolve) {
			fn = function() { resolve(getResult); };
			fn.r = 0;
			const fnQueue = function(q) { q !== queue && !depQueues.has(q) && (depQueues.add(q), q && !q.d && (fn.r++, q.push(fn))); };
			currentDeps.forEach(function(dep) { dep[webpackQueues](fnQueue); });
		});
		return fn.r ? promise : getResult();
	}
	const done = function(err) { (err ? reject(promise[webpackError] = err) : outerResolve(exports)), resolveQueue(queue); }

	body(handle, done);
	queue && queue.d < 0 && (queue.d = 0);
};